import { ApiError } from '../errors/api-error.js';
export class ReportArtifactService {
    constructor(api) { this.api = api; }
    async create(archiveGrant, idempotencyKey, options = {}) { return this.#call(() => this.api.create({ archiveGrant, idempotencyKey, description: options.description })); }
    async list() { return this.#call(() => this.api.list()); }
    async get(reportId) { return this.#call(() => this.api.get(reportId)); }
    async getViewerAccess(reportId) { return this.#call(() => this.api.getViewerAccess(reportId)); }
    async download(reportId, format) { return this.api.download(reportId, format); }
    async updateLifecycle(reportId, input) { return this.#call(() => this.api.updateLifecycle(reportId, input)); }
    async #call(operation) {
        try { const response = await operation(); return { success: response.success ?? true, data: response.data ?? response, message: response.message }; }
        catch (error) { throw error instanceof ApiError ? error : new ApiError(error.message || 'Report artifact request failed'); }
    }
}
